import { ANNIVERSARY_ICONS, type AnniversaryIcon } from "@couples/shared";
import {
  Camera,
  Cake,
  Gem,
  Gift,
  Heart,
  Home,
  PartyPopper,
  Plane,
  Sparkles,
  Star,
  type LucideIcon,
} from "lucide-react";

/** アイコン名(候補の一次情報は @couples/shared)とコンポーネントの対応。web でしか要らないためここに置く */
const ICON_COMPONENTS: Record<AnniversaryIcon, LucideIcon> = {
  heart: Heart,
  cake: Cake,
  gift: Gift,
  gem: Gem,
  home: Home,
  plane: Plane,
  camera: Camera,
  star: Star,
  party: PartyPopper,
  sparkles: Sparkles,
};

export function anniversaryIconComponentOf(icon: AnniversaryIcon): LucideIcon {
  return ICON_COMPONENTS[icon];
}

/** アイコン選択UI用。ラベル込みの並びは ANNIVERSARY_ICONS の順をそのまま使う */
export const ANNIVERSARY_ICON_OPTIONS = ANNIVERSARY_ICONS.map((option) => ({
  ...option,
  Icon: ICON_COMPONENTS[option.value],
}));
